import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-top"} maskId="square-filled-radius-0-stroke-1-IconChevronTop"><path fillRule="evenodd" clipRule="evenodd" d="M12.0001 6.29297L20.7072 15.0001L20.0001 15.7072L12.0001 7.70718L4.00008 15.7072L3.29297 15.0001L12.0001 6.29297Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronTop;
